import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { ScreenContext, DESTROY } from '@app/core/store';
import { lowerFirst } from 'lodash';
/**
 * The base class for all screens supported by `UI Studio` tool:
 * https://wiki.vermeg.com/display/PFD/Components+Store#ComponentsStore-Screens
 *
 * This class should not be modified.
 */
export class ScreenComponent implements OnInit, OnDestroy {
  /**
   * The unique identifier of the component
   */
  screenId: string;
  /**
   * The unique context identifier
   */
  ctx: ScreenContext;
  /**
   * The caller component's context
   */
  parentCtx: ScreenContext;
  /**
   * The shared parameters
   */
  params: { [key: string]: any } = {};
  /**
   * The Subjet emitter object to destroy all the subscriptions
   * when the component is destroyed
   */
  destroy$: Subject<boolean> = new Subject<boolean>();
  /**
   * The loading Observable
   */
  loading$;
  /**
   * The component's identifier
   */
  id: string;
  /**
   * The configured technical keys
   */
  keys: string;
  /**
   * The JSON data to be handled
   */
  data: any;
  /**
   * The form builder
   */
  form: FormGroup;

  constructor(
    protected activeRoute: ActivatedRoute,
    protected store: Store<any>,
    protected router: Router
  ) {}
  /**
   * Initiliazes the main properties of the component such as identifier, caller context...etc
   */
  ngOnInit() {
    this.screenId =
      this.activeRoute.snapshot.params &&
      this.activeRoute.snapshot.params.screenId
        ? this.activeRoute.snapshot.params.screenId
        : new Date().getTime().toString(32);
    this.parentCtx = this.activeRoute.snapshot.data.inputs
      ? this.activeRoute.snapshot.data.inputs.parentCtx
      : undefined;
    this.params = { ...this.defaultParams() };
    this.params = {
      ...this.params,
      workSpaceId: this.router.url.split('/')[1]
    };
  }
  /**
   * Returns the activeRoute that will be used to call other auxiliary routes
   */
  activeRouteAccess() {
    return this.activeRoute;
  }
  /**
   * The default properties
   */
  defaultParams() {
    return {
      id: this.screenId,
      parent: this.parentCtx,
      loading: false
    };
  }
  /**
   * Destroys the component and all the subscriptions
   */
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.store.dispatch({
        type: '[' +
            this.ctx.feature +
            ' ' +
            lowerFirst(this.ctx.screenType) +
            '] ' +
            DESTROY,
        id: this.screenId
    });
  }
}
